module.exports = __webpack_public_path__ + "img/main-icn-03.456b4b7c.svg";